import {
  registerAction,
  registerErrorAction,
  loginAction,
  loginErrorAction,
  userAction,
  updateAction,
} from "./action";
import axios from "axios";
import { CLEAR_USER } from "./userTypes";

const BASE_URL = "http://localhost:3100/api/v1"
const USER_URL_REGISTER = BASE_URL + "/auth/signup/custom";
const USER_URL_LOGIN = BASE_URL + "/auth/signin/custom";
const USER_URL = BASE_URL + "/users";
const UPDATE_URL = BASE_URL + "/artists";

const token = sessionStorage.getItem("auth_user");
let new_token = token !== null && JSON.parse(token).token;

const confiq = {
  headers: {
    "Content-Type": "multipart/form-data",
  },
};
const login_confiq = {
  headers: {
    "Content-Type": "application/json",
  },
};

export const registerUser = async (dispatch, users, history) => {
  try {
    const register_user = await axios.post(
      `${USER_URL_REGISTER}`,
      users,
      confiq
    );
    history.push("/register");
    dispatch(registerAction(register_user.data));
  } catch (error) {
    console.log(error.response);
    const network = { network: "No Network" };
    dispatch(
      registerErrorAction(
        error.response === undefined ? network : error.response.data.error
      )
    );
  }
};

export const loginUser = async (dispatch, users, history) => {
  try {
    const login_user = await axios.post(
      `${USER_URL_LOGIN}`,
      users,
      login_confiq
    );
    dispatch(loginAction(login_user.data));
  } catch (error) {
    console.log(error.response);
    const network = "No Network";
    dispatch(
      loginErrorAction(
        error.response === undefined ? network : error.response.data.error
      )
    );
  }
};

export const loadUser = async (dispatch) => {
  try {
    const response = await axios.get(`${USER_URL}`, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${new_token}`,
      },
    });
    dispatch(userAction(response.data.data));
  } catch (error) { }
};

export const clearUser = async (dispatch) => {
  try {
    dispatch({ type: CLEAR_USER });
  } catch (error) { }
};

export const updateUser = async (dispatch, query) => {
  try {
    const response = await axios.put(`${UPDATE_URL}`, query, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${new_token}`,
      },
    });
    dispatch(updateAction(response.data.data));
  } catch (error) { }
};
